import { render, staticRenderFns } from "./valid-doctor-tag.vue?vue&type=template&id=2d00b5e6&"
import script from "./valid-doctor-tag.vue?vue&type=script&lang=js&"
export * from "./valid-doctor-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports